module.exports = __webpack_public_path__ + "img/resized-20160702-154012.1d92ad6d.jpg";